export default "__VITE_ASSET__Do4EzYzz__"